












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SectionHeader extends Vue {
  
  @Prop({ default: '',  type: String}) title!: string;
  
  mounted() {
    
  }
  
}
